import React from "react";

export interface Token {
  accessToken: string;
  refreshToken?: string; // Add additional token properties as needed
}

export interface User {
  company: object; // Define the structure if known
  companySub: object;
  department: object;
  title: object;
  roles: string[];
  fullName?: string;
}
export const AppContext = React.createContext({
  isLoggedIn: false,
  isAdmin: false,
  isMobile: false,
  loader: false,
  setLoader: (loader: boolean) => {},
  token: null as Token | null,
  user: null as User | null,
  toast: null as React.RefObject<any> | null,
  toastTopCenter: null as React.RefObject<any> | null,
  toastCenter: null as React.RefObject<any> | null,
  companies: null as object[] | null,
  companySubs: null as object[] | null,
  locations: null as object[] | null,
  departments: null as object[] | null,
  titles: null as object[] | null,
  users: null as object[] | null,
  readers: null as object[] | null,
  leaveTypes: null as object[] | null,
  userRole: null as string | null,
  setUserRole: (role: string | null) => {},
  IsLoggedInAsync: async () => false,
  AdminLoginHandler: async (data: BodyInit | null | undefined) => {},
  LogoutHandler: () => {},
  FetchHandler: async (url: string, method: string, contentType: string | null, data: BodyInit | null | undefined, pageType: string) => ({ ok: false }),
  GetCompanies: async () => {},
  GetCompanySubs: async () => {},
  GetLocations: async () => {},
  GetDepartments: async () => {},
  GetTitles: async () => {},
  GetUsers: async () => {},
  GetReaders: async () => {},
  GetLeaveTypes: async () => {},
});
